import React from 'react';
// import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import { Select } from '@leverege/ui-redux';
import { ValuesCache } from '@leverege/value-cache';
import { ApiAccessKeyReducer, AllowedReducer, ApiProvider } from '@leverege/api-redux';
import { Table, List, Content, Toast } from '@leverege/ui-elements';
import { Toolbar, TitleBar, createConnect } from '@leverege/ui-plugin';
import I18N from '@leverege/i18n';
import { getColumns } from "./ApiAccessKeysColumns.js";
import Paginator from "./Paginator.js";
import TablePagination from "./TablePagination.js";
import Icons from "./Icons.js";
import S from './ApiAccessKeysScreen.css';
const {
  t
} = I18N.ns('apiAccessKeyManagement.ApiAccessKeysScreen');
class ApiAccessKeysScreen extends React.Component {
  static CLIENT = 'ApiAccessKeys';
  static ACTION_MATCH = {
    use: 'actionBar',
    client: ApiAccessKeysScreen.CLIENT
  };
  static TABLE_PRE_COLUMN_MATCH = {
    use: 'preActionsColumnBar',
    client: ApiAccessKeysScreen.CLIENT
  };
  static TABLE_POST_COLUMN_MATCH = {
    use: 'postActionsColumnBar',
    client: ApiAccessKeysScreen.CLIENT
  };
  static TABLE_FOOTER_MATCH = {
    use: 'actionsFooterBar',
    client: ApiAccessKeysScreen.CLIENT
  };
  static CONTEXT_MATCH = {
    use: 'contextMenu',
    client: ApiAccessKeysScreen.CLIENT
  };
  static propTypes = {
    apiAccessKeys: PropTypes.array,
    title: PropTypes.string,
    showHeader: PropTypes.bool
  };
  static defaultProps = {
    apiAccessKeys: [],
    get title() {
      return t('title');
    },
    showHeader: true
  };
  static contextType = ApiProvider.Context;
  constructor(props) {
    super(props);
    this.cache = new ValuesCache();
    this.selector = new List.SingleSelector(this, 'selection', {
      idKey: 'id'
    });
    this.paginator = new Paginator({
      onPageChange: this.onSetPage
    });
  }
  getContext(optionalUser) {
    const {
      targeted,
      actions,
      resourceId,
      api,
      emailOptions,
      smsOptions,
      uiName
    } = this.props;
    const context = {
      target: optionalUser || targeted,
      targetType: 'apiAccessKey',
      client: ApiAccessKeysScreen.CLIENT,
      resourceId,
      actions,
      api,
      emailOptions,
      uiName,
      clientProps: this.props
    };
    return context;
  }
  componentDidMount() {
    const {
      dispatch,
      actions,
      apiAccessKeysState
    } = this.props;
    dispatch(Select.clear('apiAccessKeysTargeted'));
    if (ApiAccessKeyReducer.needsLoading(apiAccessKeysState, undefined, 100)) {
      dispatch(actions.apiAccessKeys().list({
        start: 0,
        perPage: 100
      }));
    }
  }
  componentWillUnmount() {
    const {
      dispatch
    } = this.props;
    dispatch(Select.clear('apiAccessKeysTargeted'));
  }
  onSetPage = ({
    page,
    perPage
  }) => {
    const {
      dispatch,
      actions
    } = this.props;
    dispatch(actions.apiAccessKeys().list({
      start: page * perPage,
      perPage
    }));
  };
  onCheckAll = () => {
    const {
      targeted,
      apiAccessKeys,
      dispatch
    } = this.props;
    if (Select.isEmpty(targeted)) {
      const ids = apiAccessKeys.map(e => e.id);
      dispatch(Select.set(ids, 'apiAccessKeysTargeted'));
    } else {
      dispatch(Select.clear('apiAccessKeysTargeted'));
    }
  };
  onCheck = ({
    data,
    value
  }) => {
    const {
      dispatch
    } = this.props;
    dispatch(Select.toggle(data.id, 'apiAccessKeysTargeted'));
  };
  onCopyApiKey = ({
    data
  }) => {
    this.onCopyToClipboard('apiKey', data);
  };
  onCopySecret = ({
    data
  }) => {
    this.onCopyToClipboard('secret', data);
  };
  onCopyToClipboard = (name, value) => {
    navigator.clipboard.writeText(value);
    Toast.success([t('clipboard', {
      name: t(name)
    })]);
  };
  onFilter = event => {
    this.setState({
      [event.data]: event.value
    });
  };
  onUserSelected = evt => {
    const {
      dispatch,
      actions
    } = this.props;
    const user = evt.value;
    dispatch(actions.user(user.id).get({
      includeRoles: true
    }));
  };
  createDataItems = (items, offset, limit, count, status) => {
    return {
      status: status || null,
      loading: status?.includes('listing') || false,
      page: Math.ceil(offset / limit) || 0,
      perPage: limit || 100,
      count: count || 0,
      items: items || []
    };
  };
  render() {
    const {
      apiAccessKeys,
      offset,
      limit,
      count,
      status,
      targeted,
      targetedCount,
      title,
      showHeader,
      variants
    } = this.props;
    const preActionsToolbar = /*#__PURE__*/React.createElement(Toolbar, {
      variant: variants.toolbar,
      prefer: "icon",
      matchContext: ApiAccessKeysScreen.TABLE_PRE_COLUMN_MATCH,
      context: this.getContext()
    });
    const postActionsToolbar = /*#__PURE__*/React.createElement(Toolbar, {
      variant: variants.toolbar,
      prefer: "icon",
      matchContext: ApiAccessKeysScreen.TABLE_POST_COLUMN_MATCH,
      context: this.getContext()
    });
    const columns = getColumns({
      targeted,
      targetedCount,
      apiAccessKeys,
      preActionsToolbar,
      postActionsToolbar,
      onCheck: this.onCheck,
      onCheckAll: this.onCheckAll,
      onCopyApiKey: this.onCopyApiKey,
      onCopySecret: this.onCopySecret,
      variants
    });
    const dataItems = this.cache.calc('items', this.createDataItems, apiAccessKeys, offset, limit, count, status);
    this.paginator.setData(dataItems);
    return /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(Content.Area, null, /*#__PURE__*/React.createElement(Content, null, showHeader ? /*#__PURE__*/React.createElement(Content.Header, null, /*#__PURE__*/React.createElement(TitleBar, {
      icon: Icons.apiAccessKeyScreenIcon,
      title: title,
      variant: variants.titleBar
    }, /*#__PURE__*/React.createElement(Toolbar, {
      variant: variants.toolbar,
      prefer: "icon",
      hasContextMenu: true,
      contextMenuHideWhenEmpty: false,
      matchContext: ApiAccessKeysScreen.ACTION_MATCH,
      context: this.getContext()
    }))) : null, /*#__PURE__*/React.createElement(Content.Area, null, /*#__PURE__*/React.createElement(Table, {
      variant: variants.table,
      className: S.table,
      manual: true,
      sortable: true,
      pageSize: Math.min(limit, apiAccessKeys.length),
      showPagination: false,
      showPageSizeOptions: false,
      showPaginationBottom: false,
      columns: columns,
      data: this.paginator.pageItems,
      loading: this.paginator.loading,
      noDataText: t('noDataText')
    })), /*#__PURE__*/React.createElement(Content.Footer, null, /*#__PURE__*/React.createElement(TablePagination, {
      context: this.getContext(),
      matchContext: ApiAccessKeysScreen.TABLE_FOOTER_MATCH,
      paginator: this.paginator
    })))));
  }
}
const connect = createConnect(ApiAccessKeysScreen.CLIENT, {
  client: ApiAccessKeysScreen.CLIENT
});
export default connect((state, props) => {
  const {
    resourceId
  } = props;
  return {
    allowed: AllowedReducer.get(state, resourceId),
    apiAccessKeysState: ApiAccessKeyReducer.get(state, resourceId),
    apiAccessKeys: ApiAccessKeyReducer.getApiAccessKeys(state, resourceId),
    count: ApiAccessKeyReducer.getApiAccessKeyCount(state, resourceId),
    limit: ApiAccessKeyReducer.getApiAccessKeyLimit(state, resourceId),
    offset: ApiAccessKeyReducer.getApiAccessKeyOffset(state, resourceId),
    status: ApiAccessKeyReducer.getStatus(state, resourceId),
    error: ApiAccessKeyReducer.getError(state, resourceId),
    targeted: Select.get(state.select, 'apiAccessKeysTargeted'),
    targetedCount: Select.count(state.select, 'apiAccessKeysTargeted')
  };
}, null, null, {
  forwardRef: true
})(ApiAccessKeysScreen);